import React from 'react';
import {
  Box,
  Flex,
  Text,
} from '@chakra-ui/react';
import Image from "next/image";
import onTipperTable from "../../assets/on_tipper_table.png";
import { Trans } from '@lingui/macro';

const OnTipperFaq = () => {
  return (
    <Flex flexDirection="column">
      <Text mb={2}>
        <Trans>
          Untuk setiap dukungan, biaya pembayaran (payment gateway) akan ditambahkan ke jumlah tip dan dibebankan kepada pendukung berdasarkan metode pembayaran yang digunakan.
        </Trans>
      </Text>
      <Flex flexDirection="row" justifyContent="center">
        <Box
          border="4px"
          borderColor={"gray.200"}
          borderRadius="lg"
          overflow="hidden"
          w="120px"
        >
          <Box bg="orange.400" color="white" pt={7} pb={7} textAlign="center">
            <Text fontSize="xs" fontWeight="bold" height={20} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
              95%
            </Text>
          </Box>
          <Box bg="gray.100" color="black" p={4} textAlign="center">
            <Text fontSize="xs" fontWeight="bold">5%</Text>
          </Box>
        </Box >
        <Box
          borderRadius="lg"
          overflow="hidden"
          w="80px"
          pl={1}
        >
          <Box color="black" pt={7} pb={7} textAlign="left">
            <Text fontSize="xs" height={20} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }} >
              <Trans>
                Pendapatan Streamer
              </Trans>
            </Text>
          </Box>
          <Box color="black" pt={4} textAlign="left">
            <Text fontSize="xs">
              <Trans>
                Platform
              </Trans>
            </Text>
          </Box>
        </Box >
      </Flex>
      <Flex flexDirection="column" mt={3}>
        <Image src={onTipperTable} />
        <Text fontSize="xs">
          <Trans>
            *Ilustrasi Perhitungan
          </Trans>
        </Text>
      </Flex>
    </Flex>
  );
};

export default OnTipperFaq;